import React, { useState, useEffect, useContext } from "react";
import { FaEye, FaPlus } from "react-icons/fa";
import { getAllPayments } from "../../api/Api";
// import { Search } from "lucide-react";
import Loader from "../../Loader/Loader";
import Pagination from "../../Loader/Pagination";
import AllPAyment from "./AllPAyment";
import { createBill, getApprovedForms } from "../../api/Api";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../utils/AuthContext";
import { Search, Filter } from "lucide-react";
import { generateAcademicYears } from "../../utils/academicYearUtils";
const Bill = () => {
const { academicYear, setAcademicYear } = useContext(AuthContext);
  const [bills, setBills] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [approvedForms, setApprovedForms] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
const academicYears = generateAcademicYears();

  const navigate = useNavigate();

  const fetchApprovedForms = async () => {
    try {
      const data = await getApprovedForms();
      setApprovedForms(data.data);
    } catch (err) {
      console.error("Error fetching approved forms", err);
    }
  };

  useEffect(() => {
    fetchApprovedForms();
  }, []);

  const fetchBills = async () => {
    try {
      const data = await getAllPayments();
      setBills(data.reverse());
    } catch (error) {
      console.error("Error fetching bills:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBills();
  }, []);

  // Reset pagination when search or dates change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, startDate, endDate]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

const filteredBills = bills.filter((bill) => {

  const billDate = new Date(bill.date);

  const start = new Date(startDate);

  const end = new Date(endDate);

  const isWithinDateRange =
    (!startDate || billDate >= start) &&
    (!endDate || billDate <= end);

  const matchesAcademicYear =
    !academicYear ||
    bill.academicYear === academicYear ||
    approvedForms.find(
      (f) =>
        f.invoiceNo === bill.registerNo &&
        f.academicYear === academicYear
    );

  return (
    isWithinDateRange &&
    matchesAcademicYear &&
    (
      bill.fullName?.toLowerCase().includes(searchQuery) ||
      bill.registerNo?.toLowerCase().includes(searchQuery) ||
      bill._id?.toLowerCase().includes(searchQuery) ||
      bill.class?.toLowerCase().includes(searchQuery) ||
      bill.paidBy?.toLowerCase().includes(searchQuery)
    )
  );

});

  const totalPages = Math.ceil(filteredBills.length / itemsPerPage);

  const currentData = filteredBills.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="p-4 max-w-screen-xl mx-auto">

<div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4 mb-5">

  {/* Top Header */}
  <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4">

    {/* Left Side */}
    <div className="flex flex-wrap items-center gap-3">

      {/* Title */}
      <div className="mr-4">
        <h1 className="text-2xl font-bold text-[#16bab1]">
          Fee Receipt
        </h1>

        <p className="text-sm text-gray-500">
          Manage student fee payments
        </p>
      </div>

      {/* Academic Year Filter */}
      <div className="flex items-center gap-2 bg-gray-50 px-3 py-2 rounded-xl border border-gray-200 min-w-[170px]">

        <Filter size={16} className="text-[#16bab1]" />

        <div className="flex flex-col w-full">

          <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
            Academic Year
          </label>

          <select
            value={academicYear}
            onChange={(e) => setAcademicYear(e.target.value)}
            className="bg-transparent text-sm font-semibold text-gray-700 outline-none cursor-pointer"
          >
            <option value="">Overall View</option>

            {academicYears.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>

        </div>
      </div>

      {/* Search */}
      <div className="relative">

        <Search
          className="absolute left-3 top-3 text-gray-400"
          size={18}
        />

        <input
          type="search"
          value={searchQuery}
          onChange={handleSearch}
          placeholder="Search payment..."
          className="pl-10 pr-4 py-2.5 border border-gray-300 rounded-xl outline-none w-[260px] focus:ring-2 focus:ring-[#16bab1]"
        />
      </div>

      {/* Date Filters */}
      <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2">

        <div className="flex flex-col">
          <label className="text-[10px] font-bold text-gray-400 uppercase">
            From
          </label>

          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="bg-transparent outline-none text-sm"
          />
        </div>

        <div className="w-px h-8 bg-gray-300"></div>

        <div className="flex flex-col">
          <label className="text-[10px] font-bold text-gray-400 uppercase">
            To
          </label>

          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="bg-transparent outline-none text-sm"
          />
        </div>

      </div>

    </div>

    {/* Right Side Button */}
    <div>

      <button
        className="flex items-center gap-2 px-5 py-2.5 bg-[#16bab1] hover:bg-[#139a93] transition-all duration-200 text-white rounded-xl shadow-sm font-semibold whitespace-nowrap"
        onClick={() => navigate("/admin/addBill")}
      >
        <FaPlus />
        Add Bill
      </button>

    </div>

  </div>

</div>

      {loading ? (
        <Loader />
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200 rounded-lg">

            <thead className="bg-[#16bab1] text-white">
              <tr>
                <th className="py-2 px-4 border">S.No</th>
                <th className="py-2 px-4 border">Admission No</th>
                <th className="py-2 px-4 border">Student Name</th>
                <th className="py-2 px-4 border">Class</th>
                <th className="py-2 px-4 border">Year</th>
                <th className="py-2 px-4 border">CR.No</th>
                <th className="py-2 px-4 border">Paid</th>
                <th className="py-2 px-4 border">Remaining</th>
                <th className="py-2 px-4 border">Paid Mode</th>
                <th className="py-2 px-4 border">Date</th>
                <th className="py-2 px-4 border">Action</th>
              </tr>
            </thead>

            <tbody>
              {currentData.map((bill, index) => (
                <tr key={index} className="hover:bg-gray-50 text-[#16bab1]">

                  <td className="py-2 px-4 border">
                    {(currentPage - 1) * itemsPerPage + index + 1}
                  </td>

                  <td className="py-2 px-4 border">{bill.registerNo}</td>
                  <td className="py-2 px-4 border">{bill.fullName}</td>
                  <td className="py-2 px-4 border">{bill.class}</td>
                  <td className="py-2 px-4 border">
                    {bill.academicYear || 
                     approvedForms.find(f => f.invoiceNo === bill.registerNo)?.academicYear || 
                     "N/A"}
                  </td>
                  <td className="py-2 px-4 border">{bill._id}</td>
                  <td className="py-2 px-4 border">₹{bill.amount}</td>
                  <td className="py-2 px-4 border">₹{bill.remaining}</td>
                  <td className="py-2 px-4 border">{bill.paidBy}</td>

                  <td className="py-2 px-4 border">
                    {bill.date?.slice(0, 10).split("-").reverse().join("-")}
                  </td>

                  <td className="py-2 px-4 border">
                    {bill._id ? (
                      <button
                        className="text-blue-600 hover:text-blue-800 flex items-center mx-auto"
                        onClick={() => navigate(`/admin/viewBill/${bill.objectId}/${bill._id}`)}
                      >
                        <FaEye className="mr-1" /> View
                      </button>
                    ) : (
                      <span className="text-red-500">ID Missing</span>
                    )}
                  </td>

                </tr>
              ))}

              {currentData.length === 0 && (
                <tr>
                  <td colSpan="11" className="text-center py-4 text-[#16bab1]">
                    No payments found.
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
      )}

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )}

    </div>
  );
};

export default Bill;